import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Qué pasa si mi hijo no quiere ni verme?',
    a: 'El Día 1 está diseñado precisamente para eso; no necesitas que te mire para empezar el protocolo.'
  }, {
    q: '¿Funciona con adolescentes rebeldes?',
    a: 'Sí, porque el protocolo desarma la rebeldía al eliminar el conflicto.'
  }, {
    q: '¿Es difícil de leer?',
    a: 'No, está escrito de forma directa, clara y para padres con poco tiempo.'
  }, {
    q: '¿Necesito materiales extra?',
    a: 'Solo cosas que ya tienes en casa y 2 minutos de tu tiempo.'
  }];
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-16">
          <h2 className="font-heading text-3xl md:text-4xl text-navy font-bold mb-12 text-center" data-id="element-17">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-18">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-19" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm border border-amber/10 overflow-hidden" data-id="element-20">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-21">
        <span className="font-heading font-bold text-navy text-lg pr-4" data-id="element-22">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-23">
          <ChevronDownIcon className="w-6 h-6 text-amber flex-shrink-0" data-id="element-24" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-25">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-26">
            <div className="px-6 pb-5 pt-0 font-body text-charcoal text-lg" data-id="element-27">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}